
import Message1 from "../../../assets/outline/Message1.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function Message1Icon({ className, dataTestid = "Message1Icon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <Message1 data-testid={dataTestid} className={classes} {...rest} />
  );
}
